// extracted by mini-css-extract-plugin
module.exports = {"blockText":"ParsedTextBlock_blockText__fKM_5"};